import React from 'react';
import { Button } from 'tea-component';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import { IQuickActionsProps, TQuickAction } from './types';
import { QuickActionType, QUICK_ACTIONS } from './constants';
import './index.scss';

/**
 * 快速操作按钮组件
 * 提供置顶、上移、下移、置底四个快速操作
 */
export const QuickActions: React.FC<IQuickActionsProps> = ({
  selectedIndex,
  itemsLength,
  onMove,
  className,
}) => {
  /**
   * 处理快速操作按钮点击
   */
  const handleQuickAction = (event: React.MouseEvent | undefined, actionType: QuickActionType): void => {
    if (!event) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();

    // 没有选中项或只有一条数据，不允许操作
    if (selectedIndex === undefined || itemsLength <= 1) {
      return;
    }

    let targetAction: TQuickAction;

    switch (actionType) {
      case QuickActionType.Pinned:
        targetAction = 'pinned';
        break;
      case QuickActionType.AdvanceSingleStep:
        targetAction = 'advance';
        break;
      case QuickActionType.FutureSingleStep:
        targetAction = 'future';
        break;
      case QuickActionType.Trailing:
        targetAction = 'trailing';
        break;
      default:
        return;
    }

    onMove(targetAction);
  };

  /**
   * 计算按钮禁用状态
   */
  const getButtonDisabled = (buttonIndex: number): boolean => {
    // 没有选中项时，所有按钮禁用
    if (selectedIndex === undefined) {
      return true;
    }

    // 只有一条数据时，所有按钮禁用
    if (itemsLength <= 1) {
      return true;
    }

    // 选中第一项时，置顶和上移按钮禁用
    if (selectedIndex === 0) {
      return buttonIndex < 2;
    }

    // 选中最后一项时，下移和置底按钮禁用
    if (selectedIndex === itemsLength - 1) {
      return buttonIndex > 1;
    }

    return false;
  };

  return (
    <div className={classNames('dbl-quick-actions-container', className)}>
      {QUICK_ACTIONS.map((action, index) => {
        const isDisabled = getButtonDisabled(index);

        return (
          <Button
            key={action.type}
            className={classNames('dbl-quick-actions-button', {
              'dbl-quick-actions-button-disabled': isDisabled,
            })}
            disabled={isDisabled}
            onClick={(e) => handleQuickAction(e, action.action)}
          >
            <SvgIcon type={action.type} />
          </Button>
        );
      })}
    </div>
  );
};

